import { List } from 'immutable'
import { createSelector } from 'reselect'
import { getIn } from 'utils/immutable'

import { getCurrentSnapshotDate } from 'selectors/feature/snapshots'
import { createToJsSelector } from 'selectors/utils'

const notesSelector = getIn(['feature', 'notes'])

const selectFilteredNotes = createSelector(
  notesSelector,
  getCurrentSnapshotDate,
  (notes, snapshotDateString = null) => {
    if (!notes) return List()

    //  return all when there is no snapshot date
    if (!snapshotDateString) return notes

    // else filter by date
    return notes.filter((note) => {
      const noteDate = new Date(note.get('date'))
      const snapshotDate = new Date(snapshotDateString)
      const inRange = noteDate < snapshotDate || noteDate === snapshotDate
      return inRange
    })
  }
)

export const getNotes = createToJsSelector(selectFilteredNotes)

export const getNumberOfNotes = createSelector(
  selectFilteredNotes,
  (notes) => notes.size
)
